import request from '@apps-common/js-client/api/request';
import {
  PDA_ADMIN_V0_BASE_PATH,
  PDA_ADMIN_V1_BASE_PATH as base,
} from '@account/config';

export const getUsers = ({
  limit = 20,
  offset = 0,
  sort = 'email',
  descending = false,
  search = '',
  state = ['active'],
}) => {
  const params = {
    limit,
    sort: `${descending ? '-' : ''}${sort}`,
    offset,
    search,
    state__in: state.toString(),
  };

  return request.get(`${base}/users/`, {params}).then(res => res.data);
};

export const getUser = userId =>
  request.get(`${base}/users/${userId}`).then(res => res.data);

export const getMyInfo = userId =>
  request
    .get(`${PDA_ADMIN_V0_BASE_PATH}/users/${userId}`)
    .then(res => res.data);

export const updateUser = ({id, first_name, last_name, country_code}) =>
  request
    .put(`${PDA_ADMIN_V0_BASE_PATH}/users/${id}`, {
      first_name,
      last_name,
      country_code,
    })
    .then(res => res.data);

export const toggleMFA = ({id, useMFA}) =>
  request
    .post(`${base}/users/${id}/mfa/`, {use_mfa: useMFA})
    .then(res => res.data);

// state is `available` or `disabled`
export const updateUserState = ({id, state}) =>
  request.put(`${base}/users/${id}`, {state}).then(res => res.data);

// this will send an email via the configured provider
export const sendPasswordResetEmail = async userId => {
  const res = await request.post(
    `${PDA_ADMIN_V0_BASE_PATH}/users/${userId}/password-reset`
  );
  return res.data;
};
